import React from "react";

export type TooltipPosition = {
  top?: number;
  bottom?: number;
  left?: number;
  right?: number;
  containerWidth: number;
};

export type TooltipContent = React.ReactNode | undefined;

export type TooltipContextValue = {
  tooltip: TooltipContent;
  position: TooltipPosition;
};

export type TooltipControlContextValue = {
  setTooltip: (
    id: string,
    tooltip: TooltipContent,
    position: TooltipPosition,
    measurementId?: number,
  ) => void;
  clearTooltip: (id: string) => void;
  onMouseLeave: (id: string) => void;
  onMouseEnter: (id: string, measurementId: number) => void;
  onUnmountTooltip: (id: string) => void;
};

export const TooltipContext = React.createContext<TooltipContextValue>({
  tooltip: undefined,
  position: { containerWidth: 1 },
});

export const TooltipControlContext =
  React.createContext<TooltipControlContextValue>({
    setTooltip: (
      id: string,
      tooltip: TooltipContent,
      position: TooltipPosition,
    ) => {},
    clearTooltip: (id: string) => {},
    onMouseLeave: (id: string) => {},
    onMouseEnter: (id: string, measurementId: number) => {},
    onUnmountTooltip: (id: string) => {},
  });
